
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReportWhsEomDialog extends Serenity.EntityDialog<IcReportWhsEomRow, any> {
        protected getFormKey() { return IcReportWhsEomForm.formKey; }
        protected getIdProperty() { return IcReportWhsEomRow.idProperty; }
        protected getLocalTextPrefix() { return IcReportWhsEomRow.localTextPrefix; }
        protected getNameProperty() { return IcReportWhsEomRow.nameProperty; }
        protected getService() { return IcReportWhsEomService.baseUrl; }
        protected getDeletePermission() { return IcReportWhsEomRow.deletePermission; }
        protected getInsertPermission() { return IcReportWhsEomRow.insertPermission; }
        protected getUpdatePermission() { return IcReportWhsEomRow.updatePermission; }

        protected form = new IcReportWhsEomForm(this.idPrefix);

    }
}